module.exports = __webpack_public_path__ + "static/media/7.a7271c68.jpg";